import React, { Component } from 'react'
import firebase from 'firebase'
import {Helmet} from "react-helmet";
import swal from 'sweetalert2'

class Link extends Component {
  state = {
    username: this.props.username || '',
    isVerified: false,
    isFree: false
  }

  onChange = e => {
    this.setState({username: e.target.value, isVerified: false, isFree: false}, () => {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      const { username } = this.state
      const usernameEdited = username.replace(/ /g, '').replace(/,/g, '').toLowerCase()

      // not empty
      if (usernameEdited) {
        this.timeout = setTimeout(() => {
          firebase.database().ref('Usernames')
          .orderByValue()
          .equalTo(usernameEdited)
          .once('value')
          .then(snap => {
            const isFree = !Boolean(snap.val())

            this.setState({
              isVerified: true,
              isFree
            })
          })
        }, 200)
      }
    })
  }

  saveUsername = () => {
    const { username, isFree, isVerified } = this.state
    const { user } = this.props

    const usernameEdited = username.replace(/ /g, '').replace(/,/g, '').toLowerCase()

    if (isFree && isVerified && usernameEdited && user) {
      const updates = {}
      updates['Usernames/' + user.uid] = usernameEdited
      updates['List/' + user.uid] = firebase.database.ServerValue.TIMESTAMP
      firebase.database().ref().update(updates)
    } else {
      swal({
        title: 'Oops!',
        text: 'Invalid username',
        type: 'error',
        confirmButtonText: 'Got it!'
      })
    }
  }

  render() {
    const { username, isFree, isVerified } = this.state
    const usernameEdited = username.replace(/ /g, '').replace(/,/g, '').toLowerCase()

    return (
      <div>
            <Helmet   titleTemplate="auxcorde.com - %s">
            <title>username</title>
            <meta name="description" content="Nested component" />
        </Helmet>
          <div class="form">

<div class="header">



  <div class="sign-in-container ">
    <h2><span onClick={() => this.props.history.goBack()}>back</span>
</h2>
    <div class="underline-thick"></div>
  </div>

</div>

<div class="sign-in-form username">
<h3>Pick your username</h3>
        {!isVerified && username && <span></span>}
        {isVerified &&
          <span>{isFree ? 'Username is free!' : 'Username is taken.'}</span>
        }
        <br/> <br/>
        <div>
          <div>
        <input placeholder="username" type="text" value={username} onChange={this.onChange} />
        <br/>
        <p><small><i>you will get these urls.</i></small> </p>
        <div class="clearfix"></div>
        <br />
        auxcorde.com/<strong>{usernameEdited}</strong>
        <br/>
        <br/>
        <strong>{usernameEdited}</strong>.axcrd.co
        <br/>
         <br/>
         playlist.is/<strong>{usernameEdited}</strong>
        <br/>
        </div>
    
        <div class="clearfix"></div>
   
        <button  class="mt3" onClick={this.saveUsername}>join beta list</button>
    
        <br/>
        </div>

   <p><b>*</b>don't worry you can change it later.</p>
   <br/>
   <p><b>**</b>if your artist/label name is taken, email <a href="mailto:yo@auxcorde.com">yo@auxcorde.com</a> for verfication.</p>
     
  <div class="sign-up-container">
  </div>

</div>

</div>
  
<div class="aboutBtn" onClick={() => this.props.history.push('/wtf')}><span>What is it?</span></div>

      </div>
    )
  }
}

export default Link



// WEBPACK FOOTER //
// ./src/routes/Username.js